import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button, TextField } from "@material-ui/core";
import MemberList from "../Items/MemberList";
import AddActivity from "../Items/AddActivity";
import MainBox from "../Items/MainBox";
import { toast } from "react-toastify";
import Apis from "constants/Api";
import ActivitesList from "../Items/ActivitesList";
import StepDesc from "../Items/StepDesc";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export default function OpeningENGH(props) {
  const [fileName, setFileName] = useState("");

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      props.setStates({ ...props.states, creationFile: e.target.files[0] });
    } else {
      setFileName("");
    }
  };

  let isUploadedFile =
    typeof props.states.creationFile === "string" &&
    props.states.creationFile.length > 0 ? (
      <span>
        یک فایل ثبت شده است:
        <a
          className="fileDownloadButton"
          href={Apis.baseUrl + "media/" + props.states.creationFile}
        >
          دانلود
        </a>
        <Button onClick={props.deleteFile}>
          <DeleteForeverIcon style={{ color: "#f26868" }} />
        </Button>
      </span>
    ) : (
      ""
    );
  return (
    <MainBox>
      <MemberList
        groupName={props.states.groupName}
        memberList={props.states.memberList}
      />
      <StepDesc>
        تو این مرحله دیگه مدرسه انقلابتون افتتاح شده و باید مراسم افتتاحیتون رو
        با دوستاتون به اشتراک بزارید. عکسا و فیلماتون از حضور بچه ها و مهمان
        هاتون هم جاش اینجاست.
      </StepDesc>
      {/* <div className={`uploadingStep flexRow`}>
        <span> بارگذاری سین مراسم افتتاحیه</span>

        <div className="file-upload-container">
          <input
            type="file"
            id="file-upload"
            className="file-input"
            onChange={handleFileChange}
            accept=".pdf, .docx, .txt, .xlsx, .pptx,.jpeg,.jpg,.png"
          />

          <label htmlFor="file-upload" className="file-label">
            انتخاب فایل
          </label>
        </div>
        <span style={{ fontSize: "0.9em", marginRight: 20 }}>
          (حداکثر 10 مگابایت)
        </span>
      </div> */}

      {props.states.creationFile.name ? (
        <span className="file-name">
          یک فایل انتخاب شده: {props.states.creationFile.name}
        </span>
      ) : (
        isUploadedFile
      )}

      <AddActivity
        onClick={props.showModal}
        memberList={props.states.memberList}
        ActivityCounts={props.ActivityCounts}
        goForRefresh={props.goForRefresh}
      />
      <ActivitesList
        step={3}
        activities={props.activities}
        stepActs={props.stepActs}
        refresh={props.refresh}
      />
    </MainBox>
  );
}
